import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NoTransferIcon(props: IconProps) {
    return <Icon {...props} iconKey={"no_transfer"}/>
}
